// Shared assets and call to action copy for the Pler Smile Dadeland landing page.

export const CTA_LABEL = 'Reserve My Free Consultation'

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/814994ee-c9e7-424e-bf78-1fefd2988cb3.jpg',
  founder: 'https://cdn.magicpatterns.com/uploads/5nHvvv1Qz2FuoQGjAzRifs/drandreina.jpg',
  caseA: 'https://cdn.magicpatterns.com/patterns/generated-images/b6a7376f-8462-4576-b8a3-037a2fc5c47f.jpg',
  caseB: 'https://cdn.magicpatterns.com/patterns/generated-images/d8f3b288-bebe-4658-96dd-b85695c5c9a7.jpg',
  caseC: 'https://cdn.magicpatterns.com/patterns/generated-images/ad612731-aba6-4110-bebd-9dd0ab2f140e.jpg',
} as const

export function scrollToForm() {
  const el = document.getElementById('reserve')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
